import { Component, inject } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import {
  CardActionsComponent,
  CardComponent,
  CardContentComponent,
  CardHeaderComponent,
  IconComponent,
} from '@gains-com/ui-angular';
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { GoldCoinsIconComponent } from '../coins/gold-coins-icon.component.js';
import { SweepsCoinsIconComponent } from '../coins/sweeps-coins-icon.component.js';

@Component({
  selector: 'app-no-purchase-necessary-dialog',
  imports: [
    CardComponent,
    CardHeaderComponent,
    CardContentComponent,
    CardActionsComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    IconComponent,
    GoldCoinsIconComponent,
    SweepsCoinsIconComponent,
  ],
  templateUrl: './no-purchase-necessary-dialog.component.html',
  styleUrl: './no-purchase-necessary-dialog.component.scss',
})
export class NoPurchaseNecessaryDialogComponent {
  readonly dialogRef = inject(DialogRef);
}
